import { render, staticRenderFns } from "./MyFooter.vue?vue&type=template&id=5865fbeb&scoped=true&"
import script from "./MyFooter.vue?vue&type=script&lang=js&"
export * from "./MyFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865fbeb",
  null
  
)

export default component.exports